// extracted by mini-css-extract-plugin
module.exports = {"card":"_1rxdT","introducerName":"_12bYG","introducerGroup":"_1H_k1"};